<template>
  <table :class="$style['single-sample-message']" cellspacing="0" border="1">
    <tr>
      <td rowspan="5" class="first-line">样品信息</td>
      <td class="seconed-line">样品名称</td>
      <td colspan="3">
				<!--如果需要显示全部的样品名称isDisplayAll===true，则显示以“/”分隔的去重的样品名称字符串。
					如果是不显示全部的样品名称isDisplayAll===false，单样品直接显示名称，多样品显示第一个样品名称+“等样品”-->
        {{
					examination&&examination.length?(examination.length===1?examination[0].sampleName:(dataAll.isDisplayAll?data.sampleName_show:examination[0] &&
              examination[0].sampleName +"等" + examination.length + "个样品" )):'--'
        }}
      </td>
      <td class="third-line">商标</td>
      <td>
        {{ data.brand_show||'--' }}
        <!-- <div v-for="(item, i) in data.brand" :key="i">{{ item }}</div> -->
      </td>
    </tr>

    <tr>
      <td>生产单位</td>
      <td colspan="3" class="set-text-left">
        <!-- <div v-for="(item, i) in data.productionUnit_show" :key="i">
          {{ item }}
        </div> -->
        {{ data.productionUnit_show || "--" }}
      </td>

      <td>规格/型号</td>
      <td>
        <template v-if="data.specification_model.length">
          <template v-if="data.specification_model.length > 1">
            见附页
          </template>
          <template v-else>
            <div v-for="(item, i) in data.specification_model" :key="i">
              {{ item }}
            </div>
          </template>
        </template>
        <!-- {{ data.specification_model || "--" }} -->
      </td>
    </tr>
    <tr>
      <td>生产日期</td>
      <td class="set-text-left">
        <!-- <div v-for="(item, i) in data.orderProduct_date" :key="i">
          {{ item }}
        </div> -->
        {{ data.orderProduct_date_show||'--'}}
      </td>
      <td class="middle-line">生产批号</td>
      <td class="product-batch-code">
        <!-- <div v-for="(item, i) in data.productBatchCode" :key="i">
          {{ item }}
        </div> -->
        {{ data.productBatchCode_show||'--' }}
      </td>
      <td>数量</td>
      <td>
        <template v-if="hasMoreSample">见附页</template>
        <template v-else>{{ examination[0].number?(examination[0].number + '' + (examination[0].numberUnit ? examination[0].numberUnit : '批')):'--' }}</template>
      </td>
    </tr>
    <tr>
      <td>颜色、状态、包装</td>
      <td colspan="3" class="color-state-pack">
        <div class="down-message">
          颜色：
          <div class="down-line" :class="{ 'other-message': !hasMoreSample && otherStorage }">
            <template v-if="hasMoreSample|| !data.color_show">
              _______________________________________
            </template>
            <span class="sample-color" :class="{ 'sample-color-more': hasMoreSample }">
              <template v-if="hasMoreSample">见附页 </template>
              <template v-else> {{ data.color_show }}</template>
            </span>
          </div>
        </div>
        <div>
          <checkbox
            :data="stateOptions"
            :value="hasMoreSample ? [] : data.shape"
          ></checkbox>
        </div>
        <div>
          <checkbox
            :data="packOptions"
            :value="hasMoreSample ? [] : data.pack"
          ></checkbox>
        </div>
        <div class="down-message">
          其他
          <div class="down-line" :class="{ 'other-message': !hasMoreSample && otherShapeAndPack }">
            <template v-if="hasMoreSample || !otherShapeAndPack">
              ______________________________
            </template>
            <span class="sample-color" :class="{ 'sample-color-more': hasMoreSample }">
              <template v-if="hasMoreSample">见附页 </template>
							<template v-else>{{otherShapeAndPack}}</template>
            </span>
          </div>
        </div>
      </td>
      <td>存放条件</td>
      <td class="storage-message">
        <checkbox
          :data="storageOptions"
          :value="hasMoreSample ? [] : data.storage"
        ></checkbox>
        <div class="down-message">
          <div>其他</div>
          <div class="down-line" :class="{ 'other-message': !hasMoreSample && otherStorage }">
            <template v-if="hasMoreSample || !otherStorage">
            ______________________
            </template>
            <span class="sample-color" :class="{ 'sample-color-more': hasMoreSample }">
              <template v-if="hasMoreSample">见附页</template>
              <template v-else>{{otherStorage}}</template>
            </span>
            <!-- <span class="sample-storage" v-else>
              {{ otherStorage }}</span> -->
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td>备注</td>
      <td colspan="5" :class="$style['sample-code']">
        <template v-if="hasMoreSample">样品编号：见附页</template>
        <template v-else>
          样品编号：{{ examination[0].sampleCode }}；客户标识：{{ examination[0].customerCode || '--' }}
        </template>
      </td>
    </tr>
  </table>
</template>
<script>
import checkbox from "base/checkbox";
import { stateOptions, packOptions, storageOptions } from "./report-options";
export default {
  components: {
    checkbox,
  },
  props: {
    examination: Array,
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
		dataAll:{
			type:Object,
			default:function(){
				return {}
			}
		}
  },
  data() {
    return {
      stateOptions: stateOptions,
      packOptions: packOptions,
      storageOptions: storageOptions,
    };
  },
  computed: {
    hasMoreSample() {
      return this.examination.length && this.examination.length > 1;
    },
		//其他状态
		otherShape(){
			let text=this.getOtherMessage('shape',this.stateOptions)
			return text
		},
		//其他包装
		otherPack(){
			let text=this.getOtherMessage('pack',this.packOptions)
			return text
		},
		otherShapeAndPack(){
			return this.otherShape&&this.otherPack?(this.otherShape+'/'+this.otherPack):(this.otherShape||this.otherPack)
		},
		otherStorage(){
			let text=this.getOtherMessage('storage',this.storageOptions)
			return text
		}
  },
	methods:{
		getOtherMessage(key,options){
			let arr=this.data[key].filter(item=>{
				return !options.includes(item)
			})
			let text=''
			arr.forEach(item => {
				text=text?text+'/'+item:item
			});
			return text
		}
	
	}
};
</script>
<style module lang="less">
.state-checkbox {
}
.sample-code {
  text-align: left;
  padding-left: 10px !important;
}
.single-sample-message {
  // font-size: 16px;
	td{
		word-break:break-all
	}
  :global {
		.set-text-left{
			text-align: left;
		}
		.set-max-width{
			max-width: 50%;
		}
		.product-batch-code{
			word-break: break-all;
			text-align: left;
		}
    .first-line {
      width: 1em;
    }
    .seconed-line {
      width: 5em;
    }
    .middle-line {
      max-width: 4em;
    }
    .third-line {
      width: 5.5em;
    }
    .down-line {
      position: relative;
      white-space: normal;
      text-align: start;
    }
    .other-message{
      margin-left: 10px;
    }
    .sample-color {
      // position: absolute;
      white-space: normal;
      top: 0;
      text-decoration: underline;
    }
    .sample-color-more{
      position: absolute;
      text-decoration:none;
      white-space: nowrap;
      left: 10%;
    }
    .sample-storage{
      padding-left: 10px;
      text-decoration: underline;
      white-space: normal;
      line-height: 16px;
    }
    .down-message {
      display: flex;
      white-space: nowrap;
    }
    .storage-message {
      max-width: 160px;
      line-height: 25px;
      vertical-align: top;
    }
    .color-state-pack {
      line-height: 25px;
      vertical-align: top;
      width: 49%;
    }
  }
}
</style>
